import { TextSkeleton } from "@/features/projects/components/text-skeleton";
import { CheckCircleIcon, ChevronRightIcon } from "@heroicons/react/20/solid";
import { useGetContextPack } from "@/api/studio/contexts/queries";

/* Prop Types */
interface ContextFlowStepsProps {
  currentStep: string;
  contextPackId: string;
}

/*
 * ContextFlowSteps component
 * Displays each step of building a context pack
 */
export const ContextFlowSteps = ({ currentStep, contextPackId }: ContextFlowStepsProps) => {
  /* Queries */
  const { data: contextPack, isLoading: isContextPackLoading } = useGetContextPack(contextPackId);

  /* Render */
  return (
    <div className="flex items-center">
      <div className="flex  items-center px-4 mr-1">
        {isContextPackLoading && (
          <>
            <TextSkeleton variant="h3" className="w-24" />
          </>
        )}
        <ChevronRightIcon className="size-5 mr-4" />
        <h3 className="max-w-56 truncate">{contextPack?.name}</h3>
      </div>
      <ChevronRightIcon className="size-5" />
      <div className={`flex items-center justify-center p-3 ml-1 ${currentStep === "context-select" ? "border-b-2" : ""}`}>
        <p className="text-sm mr-2">Upload contexts</p>
        {currentStep !== "context-select" && <CheckCircleIcon className="size-3.5 text-success" />}
      </div>
      <ChevronRightIcon className="size-5" />
      <div className={`flex items-center justify-center p-3 ml-1 ${currentStep === "context-dropzone" ? "border-b-2" : ""}`}>
        <p className="text-sm mr-2">Add dropzones</p>
      </div>
    </div>
  );
};
